import { SettingsTab } from "./types";
import { SETTINGS_TAB_IDS } from "./constants";

export const getSettingsTabFromUrl = (): SettingsTab | null => {
  const locationHashString = location.hash.replace("#", "");

  if (!checkIsStringSettingsTab(locationHashString)) return null;

  return locationHashString;
};

export const checkIsStringSettingsTab = (
  string: string,
): string is SettingsTab => SETTINGS_TAB_IDS.includes(string as SettingsTab);

export const checkCompanyTabPermission = ({
  companyRole,
}: User.Data): boolean => companyRole === "admin" || companyRole === "owner";

export const checkCompanyMembersTabPermission = ({
  companyRole,
}: User.Data): boolean => companyRole === "admin" || companyRole === "owner";

export const checkBillingTabPermission = (
  { companyRole }: User.Data,
  company: Company.Data,
  subscriptionPlan?: SubscriptionPlan.Data,
): boolean => {
  if (!subscriptionPlan || !company) return false;

  if (companyRole !== "admin" && companyRole !== "owner") return false;

  return !subscriptionPlan.isEnterprise;
};

export const checkTrendAlertsTabPermission = (
  user: User.Data,
  company: Company.Data,
  subscriptionPlan?: SubscriptionPlan.Data,
): boolean => {
  if (!subscriptionPlan || !company) return false;

  //temporary for trend alerts to be tested on prod
  const currentUserEmail = user.email;
  const emails = [
    "romana@mytelescope.io", 
    "denys.boiko@techmagic.co", 
    "andreorefjard@gmail.com", 
    "Rodrigo+1@mytelescope.io",
    "tommy@mytelescope.io",
    "alvaro@mytelescope.io",
    "alvaro+dev@mytelescope.io",
    "alvaro+demo@mytelescope.io",
    "mykolai@mytelescope.io",
    "andrew+demo@mytelescope.io",
    "kristofer+demo@mytelescope.io",
    "carlotto@mytelescope.io",
    "rodrigo+demo@mytelescope.io",
  ];
  const isAllowedToCreateTrendAlert = emails.includes(currentUserEmail);
  //To be removed later

  return subscriptionPlan.hasAlerts || isAllowedToCreateTrendAlert;
};